import { createFileRoute, Navigate } from "@tanstack/react-router";
import { HiringProcessTemplatesPage } from "@/features/hiring-process/hiring-process-templates-page";
import { useOrganization } from "@/hooks/use-organization";
import { useOrgPath } from "@/hooks/useOrgPath";

export const Route = createFileRoute(
  "/_org/org/bu/$organizationBusinessUnitId/hiring-process/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { selectedOrgBusinessUnit } = useOrganization();
  const orgPath = useOrgPath();
  if (!selectedOrgBusinessUnit.enableHiringProcess) {
    return <Navigate to={orgPath("/home")} />;
  }
  return <HiringProcessTemplatesPage />;
}
